import {
  StrengthMeterWeakSvg,
  StrengthMeterSatisfactorySvg,
  StrengthMeterStrongSvg,
} from '../assets/StrengthMetersSvgs';
import { StrengthMeterIconProps, ModelQuality } from '../types';

export const PredictiveStrengthMeterIcon = ({ strength }: StrengthMeterIconProps) => {
  if (strength === ModelQuality.Strong) {
    return <StrengthMeterStrongSvg />;
  } else if (strength === ModelQuality.Satisfactory) {
    return <StrengthMeterSatisfactorySvg />;
  } else if (strength === ModelQuality.Weak) {
    return <StrengthMeterWeakSvg />;
  } else {
    return null;
  }
};
